import React, { useCallback, useMemo } from 'react';

import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import { Button, Tooltip } from '@mui/material';
import { GridRowModel } from '@mui/x-data-grid-pro';

import { useListagemContext } from 'context/ListagemContext';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { RequestOptionsType } from 'hooks/useRequestListagem';
import { StateNotaDevolucao } from 'pages/financeiro/nota-devolucao/types';

interface NotaDevolucaoListActionPrintProps {
    row: GridRowModel<any>;
    hidden: boolean;
}

export function NotaDevolucaoListActionPrint({ row, hidden }: NotaDevolucaoListActionPrintProps) {
    const { filter } = useListagemContext();

    const requestOptions: RequestOptionsType = useMemo(
        () => ({
            url: '/fiscal/movimentacaosimulacaodevolucao/espelhomovimentacaosimulacaodevolucao',
            sort: [{ property: 'idMovimentacaoSimulacaoDevolucao', direction: 'DESC' }],
            filter: [
                ...filter,
                {
                    property: 'nrOrdemVenda',
                    operator: 'eq',
                    value: row.nrOrdemVenda,
                    logicalOperator: 'AND',
                },
            ],
        }),
        [filter, row.nrOrdemVenda],
    );

    const { isLoadingFile, downloadFile } = useDownloadFile({
        requestOptions,
    });

    const handleClick = useCallback((): void => {
        downloadFile();
    }, [downloadFile]);

    return (
        <Tooltip title={row.tpStatus !== StateNotaDevolucao.CANCELADA ? 'Imprimir Espelho da Nota' : ''} hidden={hidden}>
            <span>
                <Button
                    sx={{ p: 0, minWidth: 'auto' }}
                    disabled={row.tpStatus === StateNotaDevolucao.CANCELADA}
                    onClick={handleClick}
                    loading={isLoadingFile}
                >
                    <PrintOutlinedIcon />
                </Button>
            </span>
        </Tooltip>
    );
}
